import "whatwg-fetch";
import Cookies from "js-cookie";
import { encodeQueryString } from "./url";

const defaultHeaders = {
  "x-requested-with": "XMLHttpRequest",
};

const defaultOptions = {
  credentials: "same-origin",
};

export default function _fetch(url, options = {}) {
  options = {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  };

  const { body, method, headers, query, ...rest } = options;

  if (query) {
    url += "?" + encodeQueryString(query);
  }

  // better post request
  if (
    method === "post" ||
    method === "put" ||
    method === "patch" ||
    method === "delete"
  ) {
    const csrfToken = getCsrfToken();
    const isFormData = body instanceof FormData;
    const extraHeaders = isFormData
      ? {}
      : { Accept: "application/json", "Content-Type": "application/json" };

    options = {
      method,
      body: isFormData ? body : body && JSON.stringify(body),
      headers: {
        "X-CSRFToken": csrfToken,
        ...extraHeaders,
        ...headers,
      },
      ...rest,
    };
  }

  return fetch(url, options).then((resp) => {
    if (resp.status === 500) {
      const message = "Ein unvorhergesehener Fehler ist aufgetreten.";
      const err = Object.assign(new Error(message), { data: { message } });
      throw err;
    }
    if (!resp.ok) {
      return resp.json().then((data) => {
        const message = data.error_message
          ? data.error_message
          : resp.statusText;
        const err = Object.assign(new Error(message), {
          data: { ...data, message },
        });
        throw err;
      });
    }
    return resp.text().then((text) => {
      if (!text || text.trim() === '') {
        return {};
      }

      try {
        return JSON.parse(text);
      } catch (e) {
        console.error("Failed to parse JSON", e);
        return {}; // or handle the error in a more appropriate way
      }
    });
  });
}

export function put(url, options) {
  return _fetch(url, { method: "put", ...options });
}

export function del(url, options) {
  return _fetch(url, { method: "delete", ...options });
}

export function post(url, options) {
  return _fetch(url, { method: "post", ...options });
}

export function patch(url, options) {
  return _fetch(url, { method: "patch", ...options });
}

export function get(url) {
  return _fetch(url, { method: "get" });
}

// get the token from teh session
function getCsrfToken() {
  return Cookies.get("csrftoken");
}
